// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"27894bca","238":"daa9e096","295":"2a5e1d41","447":"af2b57d4","615":"9d691f21","823":"168cb49f","896":"35d50527","901":"fa9c7c2e","967":"c3aad79c"}[chunkId] + ".chunk.js";
};